import React, { useContext } from 'react'
import { object } from 'prop-types'
import { Route, Switch } from 'react-router-dom'

import Header from '@Core/Components/Header'
import Footer from '@Core/Components/Footer'
import Nav from '@Core/Components/Nav'

import { UserContext } from '@Context/User'
import LandingPage from 'Pages/LandingPage'
import Home from 'Pages/Home'
import Login from 'Pages/Login'
import SignUp from 'Pages/SignUp'
import ResetPassword from 'Pages/ResetPassword'
import Disclaimer from 'Pages/Disclaimer'
import Faq from 'Pages/Faq'
import PrivacyPolicy from 'Pages/PrivacyPolicy'
import TermsAndConditions from 'Pages/TermsAndConditions'
import SuggestMissingBrand from 'Pages/SuggestMissingBrand'
import DeleteAccount from 'Pages/DeleteAccount'

import useConfirmBrowserExit from 'CustomHook/useConfirmBrowserExit'
import useIdleSessionTimeout from 'CustomHook/useIdleSessionTimeout'

const Routes = ({
  history: { location: { search = '' } = {}, push: historyPush } = {},
} = {}) => {
  useConfirmBrowserExit()
  const [state, dispatch] = useContext(UserContext)
  const isLogin = state?.userAccess?.isLogin === true
  useIdleSessionTimeout({
    isLogin,
    dispatch,
    onTimeout: () => {
      if (typeof historyPush === 'function') historyPush('/login')
    },
  })
  let params = new URLSearchParams(search)
  const isWebViewOpen = params.get('IsWebView')

  const allRoutes = (
    <>
      <Switch>
        <Route exact path="/" component={LandingPage} />

        <Route exact path="/search" component={Home} />

        <Route exact path="/login" component={Login} />

        <Route exact path="/sign-up" component={SignUp} />

        <Route exact path="/reset-password" component={ResetPassword} />

        <Route exact path="/disclaimers" component={Disclaimer} />

        <Route exact path="/faqs" component={Faq} />

        <Route exact path="/privacy-policy" component={PrivacyPolicy} />

        <Route
          exact
          path="/suggest-missing-brand"
          component={SuggestMissingBrand}
        />

        <Route
          exact
          path="/terms-and-conditions"
          component={TermsAndConditions}
        />

        <Route exact path="/delete-account" component={DeleteAccount} />
        <Route exact path="/*" component={LandingPage} />
      </Switch>
    </>
  )

  if (isWebViewOpen === 'true') {
    return <>{allRoutes}</>
  }

  return (
    <>
      <Header />
      <Nav />
      {allRoutes}
      <Footer />
    </>
  )
}

Routes.propTypes = {
  history: object.isRequired,
  location: object.isRequired,
  match: object.isRequired,
}

const RootRoutes = () => <Route component={Routes} />

export default RootRoutes
